// Pure routing seam between the lesson scene's DOM controls and the
// LessonController. Kept out of LessonScene so the mapping from an ActionBar
// choice (or a hand tap) to a controller `attempt*` call is unit-testable
// without a canvas — proving lesson taps flow through the gating controller,
// never straight into the raw `GameState` transitions free play uses.

import type { Claim } from '../game/Claims.js';
import type { AttemptResult } from '../lessons/types.js';
import type { LessonController } from '../lessons/LessonController.js';
import type { Seat } from '../game/types.js';

/**
 * Route an ActionBar choice through the controller: `null` declines the open
 * claim window (Skip), otherwise it maps the concrete `Claim` onto the matching
 * gated call. The controller decides whether the step allows it.
 */
export function applyLessonClaim(controller: LessonController, choice: Claim | null): AttemptResult {
  if (choice === null) return controller.attemptPass();
  if (choice.type === 'chi') return controller.attemptClaim(choice.seat, 'chi', choice.option);
  return controller.attemptClaim(choice.seat, choice.type);
}

/** Route a resolved hand-tap tile id through the controller's gated discard. */
export function applyLessonDiscard(
  controller: LessonController,
  seat: Seat,
  tileId: number,
): AttemptResult {
  return controller.attemptDiscard(seat, tileId);
}
